import { titleCase } from "./utilFunctions";
export const LOGIN_STATUS = {
    INITIATED: 'initiated',
    AUTHENTICATED: 'authenticated',
    NO_AUTHENTICATED: 'no-authenticated',
  };
  export const STORAGE_KEY = {
    AUTH_DATA: 'app-auth',
    ITUS: 'app-itus',
    TOKEN_EXPIRE: 'token_expire',
    POWERBI: 'powerbi',
  };
  export const API_RESPONSE_CODE = {
    FAIL: '1',
    SUCCESS: '0',
  };
  export const METHOD = {
    GET: 'get',
    POST: 'post',
    PUT: 'put'
  }
export const sukrithi=1;
export const prakrithi=2;
export const pmfby=3;
export const rwbcis=4;
export const samriddhi=5;
export const KISAN_SATHI = 7;
export const HOSPICASH = 8;
export const HEALTH_PRODUCTS = [HOSPICASH];
export const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif' ]
export const videoExtensions = ['mp4', 'mov', 'mkv', 'm4v',]
export const imageVideoAndPdfExtensions = [...imageExtensions, ...videoExtensions, 'pdf',]
export const audioExtensions = ["wav", "aiff", "aif", "flac", "alac", "ape", "mp3", "aac", "ogg", "wma", "m4a", "opus", "amr", "gsm", "dts", "ra", "rm"]


export const FIELD_SURVEY_IMAGE_KEY_VALUE = {
    'lossAffectedPlantPhoto': 'Loss Affected Plant Photo',
    'photoOfFieldAlongWithFarmer': 'Photo Of Field Along With Farmer',
    'entireFieldPhotograph': 'Entire Field Photograph',
    'lossAffectedAreaPhoto': 'Loss Affected Area Photo',
    'neighbourFieldPhoto': 'Neighbor Field Photo',
    'farmerPhotoIDAadhar': 'Farmer Photo ID Aadhar',
    'farmerKhasraOrSurveyCopyPhoto': 'Farmer Khasra Or Survey Copy Photo',
    'farmerBankPassBookPhoto': 'Farmer Bank Pass Book Photo',
    'insuranseCompanyClaimFormFilledAndSignedImage1': 'Insurance Company Claim Form Filled And Signed Image 1'
};
  
export const SORT_ORDER = {
  ASC: 'asc', 
  DESC: 'desc'
}
export const REGEX = {
  ALPHA_NUMERIC: /[^A-Za-z]/g,
  NOT_NUMBER: /[^0-9.,]/g,
  ALPHABET_REGEX: /[^A-Za-z]/g,
  FOUR_DIGIT_NUMBER_REGEX: /^[0-9]{4}$/,
  DECIMAL_NUMBER_REGEX: /^\d*\.?\d{0,2}$/,
  NUMBER_WITH_DOT:/[^0-9.]|(?<=\..*)\./g,
  NUMBER:/[^0-9.,]/g,
  NO_ZERO_START: /^0+(?!\.)/,
  ALPHANUMERIC: /[^A-Za-z0-9]/g,
  ALPHANUM_SPACE: /[^A-Za-z0-9 ]/g,
  CAPITALIZED_WORDS_REGEX: /([A-Z][a-z]*)/g
}
 
export const PAGE_NAME_KEYS = {
  CLAIM_BULK_PROCESS: 'claim-bulk-process',
  CLAIM_INTIMATION: 'claim-intimation',
  HEALTH_CLAIM_INTIMATION: "health/claim-intimation",
  USER_MANAGEMENT: 'user-management',
  BULK_SURVEY: 'bulk-survey',
  ROLE_MASTER: 'role-master',
  VENDOR_MASTER: 'vendor-master',
  VENDOR_MASTER_CREATION: 'create-edit-vendor',
  SURVEYOR_MASTER: 'surveyor-master',
  SURVEYOR_MASTER_CREATION: 'create-edit-surveyor',
  INDEMNITY_MASTER: 'indemnity-master',
  EXCESS_MASTER: 'excess-master',
  COMPENSATION_MASTER: 'compensation-master',
  CLAIM_HANDLER: 'claim-handler',
  HEALTH_CLAIM_HANDLER: 'health/claim-handler',
  CLAIM_PROCESSING: 'claim-processing',
  HEALTH_CLAIM_PROCESSING: 'health/claim-processing',
  UTR_UPLOAD: 'utr-upload',
  LOSS_RESERVE_MASTER : 'loss-reserve-master',
  ANIMAL_ATTACK: 'animal-attack-master',
  FORBIDDEN: 'forbidden',
  CLAIM_INTIMATION_DETAILS:'claim-intimation-details',
  CLAIM_DETAILS: 'claim-details',
  CLAIM_HISTORY:'claim-history',
  GIS_SURVEY:'gis-survey',
  LOSS_RESERVE:'loss-reserve',
  MANAGE_STATUS: 'manage-status',
  FIELD_SURVEY:'field-survey',
  CLAIM_CALCULATION:'claim-calculation',
  CLAIM_PAYOUT:'claim-payout',
  AUDIT_TRAIL:'audit-trail',
  DOCUMENTS: 'documents',
  CLAIM_LITIGATION:'claim-litigation',
  REMARKS_REQUEST: 'remark-request',
  CREATE_ROLE:'create-role',
  EDIT_ROLE:'edit-role',
  SAW: 'saw',
  SURVEY_MANAGEMENT: 'survey-management',
  LINE_OF_BUSINESS: 'line-of-business',
  MEDICAL_REVIEW: 'Medical Review',
  MY_WORK_ITEMS: 'my-work-items'
  
}

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const manageStatusRemarksMaxLength = 400;
export const flagClaimsMaxLength = 2500;

export const GIS_REPORT_TYPE_ARRAY = [
  { value: "all", label: "All" },
  { value: "msavi", label: "MSAVI" },
  { value: "ndmi", label: "NDMI" },
  { value: "ndvi", label: "NDVI" },
];
export const MAP_DEFAULT_CENTER = { lat: 17.38405, lng: 78.45636 };
export const PMFBY = 'PMFBY';
export const RWBCIS = 'RWBCIS'
export const GOVT_PRODUCT = [PMFBY, RWBCIS];
export const GOVT_PRODUCT_IDS =[pmfby, rwbcis]
export const DATE_FORMAT = {
  DD_MM_YYYY: 'dd-MM-yyyy',
  YYYY_MM_DD: 'yyyy-MM-dd',
  DD_MM_YYYY_HH_MM: "dd-MM-yyyy hh:mm a",
  YYYY_MM_DD_HH_MM_TIME_ZONE: "yyyy-MM-dd'T'HH:mm:ssxxx"
}

export const modes = {
  VIEW_MODE: "viewMode",
  EDIT_MODE : "editMode"
}

export const functionalities = {
  CLAIM_INTIMATION_TAB: 'Claim Intimation Tab',
  CLAIM_PROCESSING_TAB: 'Claim Processing Tab',
  CLAIM_BULK_PROCESS_TAB: 'Claim Bulk Process Tab',
  MY_WORK_ITEMS_TAB: 'My Work Items Tab',
  USER_MANAGEMENT_TAB: 'User Management Tab',
  ROLE_MASTER_TAB: 'Role Master Tab',
  SELF_SERVICE_PORTAL_TAB: 'Self Service Portal Tab',
  INTIMATION_SUMMARY_TAB: 'Intimation Summary Tab',
  GIS_SUMMARY_TAB: 'GIS Summary Tab',
  FS_SUMMARY_TAB: 'FS Summary Tab',
  CALCULATION_SUMMARY_TAB: 'Calculation Summary Tab',
  PAYOUT_SUMMARY_TAB: 'Payout Summay Tab',
  CLAIM_CREATION: 'Claim Creation',
  CLAIMS_HANDLER_ASSIGNMENT: 'Claims Handler Assignment',
  CLAIMS_HANDLER_RE_ASSIGNMENT: 'Claims Handler Re-Assignment',
  GIS_REQUEST: 'GIS Request',
  FS_REQUEST: 'FS Request',
  QC_ASSIGNMENT: 'QC Assignment',
  QC_DECISION: 'QC Decision',
  CALCULATION_REPORT: 'Calculation Report',
  CALCULATION_SUBMISSION: 'Calculation Submission',
  CLAIM_APPROVAL_DECISION: 'Claim Approval Decision',
  MODIFY_PAYOUT: 'Modify Payout',
  CLAIM_HISTORY: 'Claim History',
  AUDIT_TRAIL: 'Audit Trail',
  CLAIM_LITIGATION_PAGE: 'Claim Litigation Page',
  CLAIM_LITIGATION_SUBMISSION: 'Claim Litigation Submission',
  MANAGE_STATUS_PAGE: 'Manage Status Page',
  MANAGE_STATUS_SUBMISSION: 'Manage Status Submission',
  REMARKS_REQUEST_PAGE: 'Remarks Request Page',
  REMARKS_REQUEST_SUBMISSION: 'Remarks Request Submission',
  DOCUMENTS_PAGE: 'Documents Page',
  DOCUMENTS_UPLOAD: 'Documents Upload',
  BULK_SURVEY_TAB: 'Bulk Survey Tab',
  VENDOR_MASTER_TAB: 'Vendor Master Tab',
  SURVEYOR_MASTER_TAB: 'Surveyor Master Tab',
  INDEMNITY_MASTER_TAB: 'Indemnity Master Tab',
  CLAIM_HANDLER_MASTER_TAB: 'Claim Handler Master Tab',
  COMPENSATION_MASTER_TAB: 'Compensation Master Tab',
  EXCESS_MASTER_TAB: 'Excess Master Tab',
  ANIMAL_ATTACK_MASTER_TAB: 'Animal Attack Master Tab',
  LOSS_RESERVE_MASTER_TAB: 'Loss Reserve Master Tab',
  CLAIM_PROCESSING_LOSS_RESERVE_TAB: 'Claim Processing Loss Reserve Tab',
  CLAIM_LEGAL_EXPENSES_PAGE: 'Claim Legal Expenses Page',
  SAW: 'SAW',
  SURVEY_MANAGEMENT_TAB: 'Survey Management Tab',
  INVESTIGATION_TAB: 'Investigation Tab',
  MEDICAL_REVIEW_TAB: 'Medical Review Tab'
}

export const functionalityOrder = {
  [functionalities.CLAIM_INTIMATION_TAB]: 1,
  [functionalities.CLAIM_CREATION]: 2,
  [functionalities.CLAIMS_HANDLER_ASSIGNMENT]: 3,
  [functionalities.CLAIMS_HANDLER_RE_ASSIGNMENT]: 4,
  [functionalities.SELF_SERVICE_PORTAL_TAB]: 5,
  [functionalities.CLAIM_PROCESSING_TAB]: 6,
  [functionalities.INTIMATION_SUMMARY_TAB]: 7,
  [functionalities.CLAIM_PROCESSING_LOSS_RESERVE_TAB]: 8,
  [functionalities.GIS_SUMMARY_TAB]: 9,
  [functionalities.GIS_REQUEST]: 10,
  [functionalities.FS_SUMMARY_TAB]: 11,
  [functionalities.FS_REQUEST]: 12,
  [functionalities.INVESTIGATION_TAB]: 13,
  [functionalities.MEDICAL_REVIEW_TAB]:13,
  [functionalities.QC_ASSIGNMENT]: 13,
  [functionalities.QC_DECISION]: 14,
  [functionalities.CALCULATION_SUMMARY_TAB]: 15,
  [functionalities.CALCULATION_REPORT]: 16,
  [functionalities.CALCULATION_SUBMISSION]: 17,
  [functionalities.CLAIM_APPROVAL_DECISION]: 18,
  [functionalities.PAYOUT_SUMMARY_TAB]: 19,
  [functionalities.MODIFY_PAYOUT]: 20,
  [functionalities.CLAIM_HISTORY]: 21,
  [functionalities.AUDIT_TRAIL]: 22,
  [functionalities.CLAIM_LITIGATION_PAGE]: 23,
  [functionalities.CLAIM_LITIGATION_SUBMISSION]: 24,
  [functionalities.CLAIM_LEGAL_EXPENSES_PAGE]: 25,
  [functionalities.MANAGE_STATUS_PAGE]: 26,
  [functionalities.MANAGE_STATUS_SUBMISSION]: 27,
  [functionalities.REMARKS_REQUEST_PAGE]: 28,
  [functionalities.REMARKS_REQUEST_SUBMISSION]: 29,
  [functionalities.DOCUMENTS_PAGE]: 30,
  [functionalities.DOCUMENTS_UPLOAD]: 31,
  [functionalities.MY_WORK_ITEMS_TAB]: 31,
  [functionalities.CLAIM_BULK_PROCESS_TAB]: 32,
  [functionalities.BULK_SURVEY_TAB]: 33,
  [functionalities.USER_MANAGEMENT_TAB]: 34,
  [functionalities.ROLE_MASTER_TAB]: 35,
  [functionalities.VENDOR_MASTER_TAB]: 36,
  [functionalities.SURVEYOR_MASTER_TAB]: 37,
  [functionalities.INDEMNITY_MASTER_TAB]: 38,
  [functionalities.CLAIM_HANDLER_MASTER_TAB]: 39,
  [functionalities.COMPENSATION_MASTER_TAB]: 40,
  [functionalities.EXCESS_MASTER_TAB]: 41,
  [functionalities.ANIMAL_ATTACK_MASTER_TAB]: 42,
  [functionalities.LOSS_RESERVE_MASTER_TAB]: 43,
  [functionalities.SAW]: 44,
  [functionalities.SURVEY_MANAGEMENT_TAB]: 45,
}

export const ERROR_MESSAGE = "Something went wrong, please try again";
export const IMAGE_TYPE = {
  FIELD_SURVEY: 'field_survey',
  CLAIM_FORM: 'claim_form'
}

export const animalList = [
    { label: "Nilgai", value: "Nilgai" },
    { label: "Elephant", value: "Elephant" },
    { label: "Wild Boar", value: "Wild Boar" },
    { label: "Monkey", value: "Monkey" },
    { label: "Rabbit", value: "Rabbit" }
];

export const updatedAnimalList = [
  { label: "Elephant", value: "Elephant" },
  { label: "Wild Boar", value: "Wild Boar" },
]

export const KISAN_SATHI_ANIMAL_LIST = [
  { label: "Elephant", value: "Elephant" },
  { label: "Wild Boar", value: "Wild Boar" },
]

export const relationshipOptions = [
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Spouse", label: "Spouse" },
    { value: "Son", label: "Son" },
    { value: "Daughter", label: "Daughter" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Others", label: "Others" }
];

export const SELF = "Self";
export const BANK_EMPLOYEE = "Bank Employee";
export const OTHER = "Other";

export const claimIntimatedByOptions = [
    { value: SELF, label: SELF },
    { value: OTHER, label: OTHER }
];

export const kisanSathiClaimIntimatedByOptions = [
    { value: SELF, label: SELF },
    {value: BANK_EMPLOYEE, label: BANK_EMPLOYEE},
    { value: OTHER, label: OTHER }
];

export const fieldSurveyStatus ={
  ASSIGNED: "ASSIGNED",
  WORK_IN_PROGRESS: "WORK_IN_PROGRESS",
  SAVED_AS_DRAFT : "SAVED_AS_DRAFT",
  COMPLETED : "COMPLETED",
  IN_COMPLETE: "IN_COMPLETE"
}

export const RECLOSE = "reclose"

export const measureTypeOptions = [
  { label: "Physical Deterrents", value: "Physical Deterrents" },
  { label: "Biological Deterrents", value: "Biological Deterrents" },
  { label: "Visual Repellents", value: "Visual Repellents" },
  { label: "Chemical Repellents", value: "Chemical Repellents" }
]

export const preventiveMeasureOptions  = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' }
]

export const NILGAI = "Nilgai";

export const STATUS_IN_PROGRESS = "in progress";

export const STATUS_COMPLETED = "completed";

export const STATUS_REJECTED = "rejected";

export const STATUS_APPROVED = "approved";

export const VENDOR_MANAGER = "Vendor Manager";
export const CLAIMS_HANDLER = "CLAIMS_HANDLER";
export const CH_SUPPORT = "CH_SUPPORT"
export const AGRI = "agri"
export const HEALTH = "health"
export const BUSINESS_OPTIONS = [
    {
        name: 'Agri',
        icon: '/kshemaImages/agri.svg',
        key: AGRI
    },
    {
        name: 'Health',
        icon: '/kshemaImages/health.svg',
        key: HEALTH
    },
];
export const COLUMN_TYPE = {
  date: "date",
  dateTime: "dateTime",
}
export const claimIngestionTypes = [
  { id: 1, label: "Individual", value: "Individual" },
  { id: 2, label: "Area Based", value: "Area Based" },
];
export const INDIVIDUAL = 1
export const AREA_BASED = 2
export const searchTypes = [
  { label: "Policy ID", value: 1 },
  { label: "Mobile Number", value: 2 },
  { label: "Farmer ID", value: 3 },
  { label: "Bank Account Number", value: 4 },
  { label: "Advance Search", value: 5 },
];
export const seasonValues = [
  { label: "Rabi", value: "Rabi" },
  { label: "Kharif", value: "Kharif" },
];

// In House Products options added it manually
export const policyStatus = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const claimPendingActions = [
  { label: "Claim without policy", value: "Claim without policy" },
  { label: "Grievance", value: "Grievance" },
  { label: "Reopen Request", value: "Reopen" },
  { label: "Follow up", value: "Follow Up" },
  { label: "Other remarks", value: "Others" },
];
export const attachmentAvailabilityOptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
export const potentialLitigationOptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
export const RejectedLetterEndDate = new Date("2025-09-22").setHours(11, 59, 59, 999) // call the API for Rejected from manage status if claim raised before this time
export const KSHEMA_HOSPI_DINDHAN_SURAKSHA = "Kshema Hospi DinDhan Suraksha";
export const healthProducts = [{ label: KSHEMA_HOSPI_DINDHAN_SURAKSHA, value: 8 }]

export const INVESTIGATION_TYPES = {
  GENERAL: "GENERAL",
  MEDICAL: "MEDICAL"
};

export const REVIEW_TYPES = {
  INVESTIGATION: "Investigation",
  MEDICAL_REVIEW: "medicalReview"
};

export const RISK = "RISK_TEAM";
export const validFileTypes = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];



export const Litigationvalidtypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/jpg",
    "image/bmp",
    "image/webp",
    "image/svg+xml",
    "image/tiff",
    "video/ogg",
    "video/mp4",
    "video/webm",
    "video/quicktime",
    "video/x-msvideo",
    "video/x-ms-wmv",
    "video/x-matroska",
    "application/pdf",
    "application/msword",
  ];
export const flagIcons = {
  1: { label: "Fraud", img: "/kshemaImages/e911_emergency.png" },
  2: { label: "Potential Litigation", img: "/kshemaImages/emergency_home.png" },
  3: { label: "Litigation", img: "/kshemaImages/balance.png" },
  4: { label: "Suspicious", img: "/kshemaImages/Suspicious.svg" },
};
export const FRAUD = 1
export const POTENTIAL_LITIGATION = 2
export const LITIGATION = 3
export const SUSPICIOUS = 4

export const unitOptions = ["Ankanam", "Arc", "Bigha", "Biswani", "Biswa", "Biswa kacha", "Cents", "Dhur", "Dismil", "Gajam", "Ground", "Guntas", "Hectare", "Kanal", "Katha", "Kuncham", "Lessa", "Marla", "Square Feet", "Square Yards", "Square meters", "Acre"];

export const isValidDamageArea = (value) => {
  return /^\d*\.?\d{0,2}$/.test(value);
};

export const additionalQuestionPerils = ["flood", "inundation"]

export  const claimPendindActions = [
    { label: "Claim without policy", value: "Claim without policy" },
    { label: "Grievance", value: "Grievance" },
    { label: "Reopen Request", value: "Reopen" },
    { label: "Follow up", value: "Follow Up" },
    {label:"Lat Long Checked",value:"Lat Long Checked"},
    { label: "Other remarks", value: "Others" }
  ];

export const ALERT_PROXIMATE_CAUSE_MISMATCH = "Proximate Cause is not matching with the peril insured, are you sure you want to proceed.";

export const NEW_POLICIES_START_DATE = process.env.REACT_APP_NEW_POLICIES_START_DATE
export const ABSOLUTE_VALUE_OPTION = {
  value: "",
  label: "Absolute Value",
  displayText: "₹"
}
export const PERCENTAGE = "percentage"
export const PERCENTAGE_OPTION = {
    value: PERCENTAGE,
    label: "Percentage",
    displayText: "%"
  }
export const SALVAGE_TYPES = [
  ABSOLUTE_VALUE_OPTION,
  PERCENTAGE_OPTION
]